import { BaseEntity } from '../../xform-compat';
import { Permission } from './permission.model';
import { BasicUser } from './basicUser.model';
import { Searchable } from './searchable.interface';
import { Tenant } from './tenant.model';


export class Role implements BaseEntity, Searchable {
  id: number;
  name: string;
  description: string;
  active: boolean;
  permissions: Array<Permission>;
  timesApplied: number;
  noOfPermissions: number;
  createdBy: BasicUser;
  updated: string;
  created: string;
  tenant: Tenant;

  constructor(role?: any) {
    this.id = role.id || null;
    this.name = role.name || '';
    this.description = role.description || '';
    this.active = role.active || false;
    this.permissions = role.permissions ? role.permissions : [];
    this.timesApplied = role.timesApplied || null;
    this.noOfPermissions = role.noOfPermissions || null;
    this.createdBy = role.createdBy || null;
    this.tenant = role.tenant || null;
  }

  public getDisplayName() {
    return this.name;
  }
}

